export function inRange (quantity, min, max) {
  // Ensure quantity is defined
  quantity = quantity == null ? 0 : quantity

  return quantity >= min && quantity <= max
}
